var e={wrapper:"Debugger__wrapper-2C2",debugger:"Debugger__debugger-llr"};export{e as default};
